// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scroll container */
.card-table {
  background-color: #1a0757;
   overflow-y: auto;
  padding-right: 6px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius:8px;
   border: 1px solid #1f2937;
}



.data-card {   
  border-radius: 14px;
  padding: 12px 14px;
  margin: 10px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  opacity: 1;
}


/* Card base */
.data-card {
  border-radius: 14px;
  padding: 12px 14px;
  margin:10px;
  color: #efe9e9;
  font-size: 13px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.data-card:hover {
  transform: scale(1.01);
}

/* Alternate colors */
.card-blue {
  background-color: #035439;
}

.card-purple {
  background-color: #04375e;
}

/* Card layout */
.card-top {
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 16px;
}

/* Fields */
.field {
  margin-bottom: 6px;
}

.field.inline {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

/* Text styles */
.label {
  font-size: 12px;
  font-weight: 600;
  color: #ffe600;
  margin-right: 4px;
}

.value {
  font-size: 13px;
  font-weight: 600;
}

.value.small {
  font-size: 12px;
  line-height: 1.3;
}

/* Chips */
.chip {
  background: rgba(255, 255, 255, 0.2);
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
}

/* Bottom */
.card-bottom {
  margin-top: 8px;
}

/* Button */
.details-btn {
  background: #a72b2b;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.details-btn:hover {
  background: #8f2323;
}

/* Scrollbar (optional) */
.card-table::-webkit-scrollbar {
  width: 6px;
}

.card-table::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}

.status-live {
  display: inline-block;
  background-color: #28a745; /* bright green */
  color: #fff;
  padding: 2px 6px;          /* smaller padding */
  border-radius: 10px;
  font-weight: 200;
  font-size: 8px;           /* smaller font */
  position: relative;
  overflow: hidden;

  animation: pulse 1.5s infinite;
}

/* pulsating glow around badge */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 6px 6px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}

/* optional small green dot on left */
.status-live::before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #28a745;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  animation: pulse-dot 1.5s infinite;
  vertical-align: middle;
}

@keyframes pulse-dot {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}


/* // color change */

.blink-danger-text_Narmal {
  border: 1px solid #f0eded;
  animation: dangerTextBlinkNarmal 20s infinite;
  font-weight: bold;
}
@keyframes dangerTextBlinkNarmal {
  0% {
    color: rgb(120, 212, 133);
    opacity: 1;
  }
  50% {
   color: rgb(120, 212, 133);
    opacity: 0;
  }
  100% {
    color: rgb(120, 212, 133);
    opacity: 1;
  }
}

.blink-danger-text {
  border: 1px solid #f0eded;
  animation: dangerTextBlink 1s infinite;
  font-weight: bold;
}

@keyframes dangerTextBlink {
  0% {
    color: red;
    opacity: 1;
  }
  50% {
    color: red;
    opacity: 0;
  }
  100% {
    color: red;
    opacity: 1;
  }
}

/* Offline = blinking red */
.blink-danger-text {
  animation: dangerTextBlink 20s infinite;
  color: red;
  font-weight: bold;
}

/* Live = stable green */
.status-live {
  color: #2ecc71;
  font-weight: bold;
}

@keyframes dangerTextBlink {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes blinkText {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes blinkText {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
/* // ANIMINATION */
.card-danger {
  color: #df2c2c !important;
  
}
@keyframes dangerBlink {
  0% {
    color: #df2c2c;
    opacity: 1;
  }
  50% {
    color: #ff6b6b;
    opacity: 0.4;
  }
  100% {
    color: #df2c2c;
    opacity: 1;
  }
}

.card-danger {
  color: #ff3b3b !important;
  font-weight: 700;
  animation: dangerBlink 1s infinite;
 color: #df2c2c !important;
  font-weight: 600;
  
}
.card-danger .card-value {
  color: #df2c2c !important;
  font-weight: 600;
  text-align:center;
}


/* CODE FOR DIV MAXIMIZE MINIMIZE  */
/* Background overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Popup box */
.popup {
  background: #fff;
  width: 400px;
  padding: 20px;
  border-radius: 8px;
  position: relative;
}

/* Close button */
.close {
  position: absolute;
  top: 8px;
  right: 10px;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
}

/* CODE FOR DIV MAXIMIZE MINIMIZE  */

/* Overlay */
.scada-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Container */
.scada-container {
  background: #0d1b2a;
  width: 90%;
  height: 85%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

/* Fullscreen */
.scada-overlay.fullscreen .scada-container {
  width: 100vw;
  height: 100vh;
  border-radius: 0;
}

/* Header */
.scada-header {
  background: linear-gradient(90deg, #0f8792, #8eccca);
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.scada-header h6 {
  margin: 0;
  font-weight: 600;
}

.maximize-btn {
  border: none;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

/* Stats */
.stats-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
}

.stat {
  padding: 4px 8px;
  border-radius: 4px;
  color: white;
  font-weight: bold;
}

.blue { background: linear-gradient(90deg, #6743de, #0f1f5e); }
.red { background: #df2c2c; }
.green { background: #098328; }

/* Table */
.table-wrapper {
  flex: 1 1;
  overflow: auto;
}

sacda-table table {
  width: 100%;
  border-collapse: collapse;
}

.sacda-table thead {
  position: sticky;
  top: 0;
  background: #f2f2f2;
}

.sacda-table th, td {
  padding: 8px;
  text-align: center;
}

.sacda-table tbody tr:nth-child(even) {
  background: #222a33;
  color: white;
}

.sacda-table tbody tr:nth-child(odd) {
  background: #0d1b2a;
  color: white;
}

.sacda-table tbody tr:nth-child(odd) {
  background: #0d1b2a;
  color: white;
}

/* Status */
.online { color: #2ecc71; font-weight: bold; }
.offline { color: red; font-weight: bold; }

/* Alerts */
.danger { color: red; font-weight: bold; }

@keyframes blinkText {
  50% { opacity: 0; }
}

.blink {
  animation: blinkText 1s infinite;
}


.scada {
  display: grid;
  grid-template-columns: 3fr 1.2fr;
  grid-template-rows: 1fr 1fr;
  height: 80vh;
  gap: 4px;
  padding: 4px;
  background: #ecf0f0;
}

/* Common panel */
.panel {
  background: #1e2f3c;
  color: #fff;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Panel header */
.panel-header {
  display: flex;
  float: right;
}

.maxbutton {
  background-color: #0c231f;   /* Nice green color */
  color: #fff;                  /* White text */
  border: none;                 /* Remove border */
  border-radius: 4px;           /* Rounded corners */
  padding: 4px 10px;            /* Some padding */
  cursor: pointer;              /* Pointer on hover */
  float: right;                 /* Float to the right */
  font-size: 0.9rem;            /* Slightly smaller text */
  transition: background 0.2s;  /* Smooth hover */
}

.panel-header button {
  background-color: #1abc9c;   /* Nice green color */
  color: #fff;                  /* White text */
  border: none;                 /* Remove border */
  border-radius: 4px;           /* Rounded corners */
  padding: 4px 10px;            /* Some padding */
  cursor: pointer;              /* Pointer on hover */
  float: right;                 /* Float to the right */
  font-size: 0.9rem;            /* Slightly smaller text */
  transition: background 0.2s;  /* Smooth hover */
}

.panel-header button:hover {
  background-color: #16a085;    /* Darker green on hover */
}

/* Panel body */
.panel-body {
  flex: 1 1;
  padding: 10px;
  overflow: auto;
}

/* Grid positions */
.div1 { grid-column: 1; grid-row: 1; }
.div4 { grid-column: 1; grid-row: 2; }

.div2 { grid-column: 2; grid-row: 1; }
.div3 { grid-column: 2; grid-row: 2; }

/* Expand inside column */
.expand {
  grid-row: 1 / span 2;
}


.thStyle {
        border: 1px solid #ccc;      
   background-color:#09564e;
        color: white;
        text-Align: center;
        font-Size: 14px;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/GisTools/SCADAHOMECSS.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,yBAAyB;GACxB,gBAAgB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;GAChB,yBAAyB;AAC5B;;;;AAIA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kDAAkD;EAClD,UAAU;AACZ;;;AAGA,cAAc;AACd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB,EAAE,iBAAiB;EAC5C,WAAW;EACX,gBAAgB,WAAW,oBAAoB;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,YAAY,iBAAiB;EAC3C,kBAAkB;EAClB,gBAAgB;;EAEhB,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;;AAGA,oBAAoB;;AAEpB;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE;IACE,yBAAyB;IACzB,UAAU;EACZ;EACA;GACC,yBAAyB;IACxB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,uCAAuC;EACvC,UAAU;EACV,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;AACA,mBAAmB;AACnB;EACE,yBAAyB;;AAE3B;AACA;EACE;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;CACnC,yBAAyB;EACxB,gBAAgB;;AAElB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA,oCAAoC;AACpC,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,QAAQ,oDAAoD,EAAE;AAC9D,OAAO,mBAAmB,EAAE;AAC5B,SAAS,mBAAmB,EAAE;;AAE9B,UAAU;AACV;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,WAAW;AACX,UAAU,cAAc,EAAE,iBAAiB,EAAE;AAC7C,WAAW,UAAU,EAAE,iBAAiB,EAAE;;AAE1C,WAAW;AACX,UAAU,UAAU,EAAE,iBAAiB,EAAE;;AAEzC;EACE,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,gCAAgC;AAClC;;;AAGA;EACE,aAAa;EACb,gCAAgC;EAChC,2BAA2B;EAC3B,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB,IAAI,qBAAqB;EAClD,WAAW,mBAAmB,eAAe;EAC7C,YAAY,kBAAkB,kBAAkB;EAChD,kBAAkB,YAAY,oBAAoB;EAClD,iBAAiB,aAAa,iBAAiB;EAC/C,eAAe,eAAe,qBAAqB;EACnD,YAAY,kBAAkB,uBAAuB;EACrD,iBAAiB,aAAa,0BAA0B;EACxD,2BAA2B,GAAG,iBAAiB;AACjD;;AAEA;EACE,yBAAyB,IAAI,qBAAqB;EAClD,WAAW,mBAAmB,eAAe;EAC7C,YAAY,kBAAkB,kBAAkB;EAChD,kBAAkB,YAAY,oBAAoB;EAClD,iBAAiB,aAAa,iBAAiB;EAC/C,eAAe,eAAe,qBAAqB;EACnD,YAAY,kBAAkB,uBAAuB;EACrD,iBAAiB,aAAa,0BAA0B;EACxD,2BAA2B,GAAG,iBAAiB;AACjD;;AAEA;EACE,yBAAyB,KAAK,0BAA0B;AAC1D;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA,mBAAmB;AACnB,QAAQ,cAAc,EAAE,WAAW,EAAE;AACrC,QAAQ,cAAc,EAAE,WAAW,EAAE;;AAErC,QAAQ,cAAc,EAAE,WAAW,EAAE;AACrC,QAAQ,cAAc,EAAE,WAAW,EAAE;;AAErC,yBAAyB;AACzB;EACE,oBAAoB;AACtB;;;AAGA;QACQ,sBAAsB;GAC3B,wBAAwB;QACnB,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB","sourcesContent":["/* Scroll container */\n.card-table {\n  background-color: #1a0757;\n   overflow-y: auto;\n  padding-right: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  border-radius:8px;\n   border: 1px solid #1f2937;\n}\n\n\n\n.data-card {   \n  border-radius: 14px;\n  padding: 12px 14px;\n  margin: 10px;\n  color: #fff;\n  font-size: 13px;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n  opacity: 1;\n}\n\n\n/* Card base */\n.data-card {\n  border-radius: 14px;\n  padding: 12px 14px;\n  margin:10px;\n  color: #efe9e9;\n  font-size: 13px;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.data-card:hover {\n  transform: scale(1.01);\n}\n\n/* Alternate colors */\n.card-blue {\n  background-color: #035439;\n}\n\n.card-purple {\n  background-color: #04375e;\n}\n\n/* Card layout */\n.card-top {\n  display: grid;\n  grid-template-columns: 1fr 1.3fr;\n  gap: 16px;\n}\n\n/* Fields */\n.field {\n  margin-bottom: 6px;\n}\n\n.field.inline {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n/* Text styles */\n.label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffe600;\n  margin-right: 4px;\n}\n\n.value {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.value.small {\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n/* Chips */\n.chip {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n/* Bottom */\n.card-bottom {\n  margin-top: 8px;\n}\n\n/* Button */\n.details-btn {\n  background: #a72b2b;\n  color: #fff;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 18px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.details-btn:hover {\n  background: #8f2323;\n}\n\n/* Scrollbar (optional) */\n.card-table::-webkit-scrollbar {\n  width: 6px;\n}\n\n.card-table::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 10px;\n}\n\n.status-live {\n  display: inline-block;\n  background-color: #28a745; /* bright green */\n  color: #fff;\n  padding: 2px 6px;          /* smaller padding */\n  border-radius: 10px;\n  font-weight: 200;\n  font-size: 8px;           /* smaller font */\n  position: relative;\n  overflow: hidden;\n\n  animation: pulse 1.5s infinite;\n}\n\n/* pulsating glow around badge */\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 6px 6px rgba(40, 167, 69, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n  }\n}\n\n/* optional small green dot on left */\n.status-live::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background-color: #28a745;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 4px;\n  animation: pulse-dot 1.5s infinite;\n  vertical-align: middle;\n}\n\n@keyframes pulse-dot {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.3);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n\n/* // color change */\n\n.blink-danger-text_Narmal {\n  border: 1px solid #f0eded;\n  animation: dangerTextBlinkNarmal 20s infinite;\n  font-weight: bold;\n}\n@keyframes dangerTextBlinkNarmal {\n  0% {\n    color: rgb(120, 212, 133);\n    opacity: 1;\n  }\n  50% {\n   color: rgb(120, 212, 133);\n    opacity: 0;\n  }\n  100% {\n    color: rgb(120, 212, 133);\n    opacity: 1;\n  }\n}\n\n.blink-danger-text {\n  border: 1px solid #f0eded;\n  animation: dangerTextBlink 1s infinite;\n  font-weight: bold;\n}\n\n@keyframes dangerTextBlink {\n  0% {\n    color: red;\n    opacity: 1;\n  }\n  50% {\n    color: red;\n    opacity: 0;\n  }\n  100% {\n    color: red;\n    opacity: 1;\n  }\n}\n\n/* Offline = blinking red */\n.blink-danger-text {\n  animation: dangerTextBlink 20s infinite;\n  color: red;\n  font-weight: bold;\n}\n\n/* Live = stable green */\n.status-live {\n  color: #2ecc71;\n  font-weight: bold;\n}\n\n@keyframes dangerTextBlink {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@keyframes blinkText {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@keyframes blinkText {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n  100% { opacity: 1; }\n}\n/* // ANIMINATION */\n.card-danger {\n  color: #df2c2c !important;\n  \n}\n@keyframes dangerBlink {\n  0% {\n    color: #df2c2c;\n    opacity: 1;\n  }\n  50% {\n    color: #ff6b6b;\n    opacity: 0.4;\n  }\n  100% {\n    color: #df2c2c;\n    opacity: 1;\n  }\n}\n\n.card-danger {\n  color: #ff3b3b !important;\n  font-weight: 700;\n  animation: dangerBlink 1s infinite;\n color: #df2c2c !important;\n  font-weight: 600;\n  \n}\n.card-danger .card-value {\n  color: #df2c2c !important;\n  font-weight: 600;\n  text-align:center;\n}\n\n\n/* CODE FOR DIV MAXIMIZE MINIMIZE  */\n/* Background overlay */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Popup box */\n.popup {\n  background: #fff;\n  width: 400px;\n  padding: 20px;\n  border-radius: 8px;\n  position: relative;\n}\n\n/* Close button */\n.close {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  border: none;\n  background: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* CODE FOR DIV MAXIMIZE MINIMIZE  */\n\n/* Overlay */\n.scada-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.6);\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Container */\n.scada-container {\n  background: #0d1b2a;\n  width: 90%;\n  height: 85%;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Fullscreen */\n.scada-overlay.fullscreen .scada-container {\n  width: 100vw;\n  height: 100vh;\n  border-radius: 0;\n}\n\n/* Header */\n.scada-header {\n  background: linear-gradient(90deg, #0f8792, #8eccca);\n  padding: 10px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.scada-header h6 {\n  margin: 0;\n  font-weight: 600;\n}\n\n.maximize-btn {\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n/* Stats */\n.stats-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 8px;\n}\n\n.stat {\n  padding: 4px 8px;\n  border-radius: 4px;\n  color: white;\n  font-weight: bold;\n}\n\n.blue { background: linear-gradient(90deg, #6743de, #0f1f5e); }\n.red { background: #df2c2c; }\n.green { background: #098328; }\n\n/* Table */\n.table-wrapper {\n  flex: 1;\n  overflow: auto;\n}\n\nsacda-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.sacda-table thead {\n  position: sticky;\n  top: 0;\n  background: #f2f2f2;\n}\n\n.sacda-table th, td {\n  padding: 8px;\n  text-align: center;\n}\n\n.sacda-table tbody tr:nth-child(even) {\n  background: #222a33;\n  color: white;\n}\n\n.sacda-table tbody tr:nth-child(odd) {\n  background: #0d1b2a;\n  color: white;\n}\n\n.sacda-table tbody tr:nth-child(odd) {\n  background: #0d1b2a;\n  color: white;\n}\n\n/* Status */\n.online { color: #2ecc71; font-weight: bold; }\n.offline { color: red; font-weight: bold; }\n\n/* Alerts */\n.danger { color: red; font-weight: bold; }\n\n@keyframes blinkText {\n  50% { opacity: 0; }\n}\n\n.blink {\n  animation: blinkText 1s infinite;\n}\n\n\n.scada {\n  display: grid;\n  grid-template-columns: 3fr 1.2fr;\n  grid-template-rows: 1fr 1fr;\n  height: 80vh;\n  gap: 4px;\n  padding: 4px;\n  background: #ecf0f0;\n}\n\n/* Common panel */\n.panel {\n  background: #1e2f3c;\n  color: #fff;\n  border-radius: 6px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Panel header */\n.panel-header {\n  display: flex;\n  float: right;\n}\n\n.maxbutton {\n  background-color: #0c231f;   /* Nice green color */\n  color: #fff;                  /* White text */\n  border: none;                 /* Remove border */\n  border-radius: 4px;           /* Rounded corners */\n  padding: 4px 10px;            /* Some padding */\n  cursor: pointer;              /* Pointer on hover */\n  float: right;                 /* Float to the right */\n  font-size: 0.9rem;            /* Slightly smaller text */\n  transition: background 0.2s;  /* Smooth hover */\n}\n\n.panel-header button {\n  background-color: #1abc9c;   /* Nice green color */\n  color: #fff;                  /* White text */\n  border: none;                 /* Remove border */\n  border-radius: 4px;           /* Rounded corners */\n  padding: 4px 10px;            /* Some padding */\n  cursor: pointer;              /* Pointer on hover */\n  float: right;                 /* Float to the right */\n  font-size: 0.9rem;            /* Slightly smaller text */\n  transition: background 0.2s;  /* Smooth hover */\n}\n\n.panel-header button:hover {\n  background-color: #16a085;    /* Darker green on hover */\n}\n\n/* Panel body */\n.panel-body {\n  flex: 1;\n  padding: 10px;\n  overflow: auto;\n}\n\n/* Grid positions */\n.div1 { grid-column: 1; grid-row: 1; }\n.div4 { grid-column: 1; grid-row: 2; }\n\n.div2 { grid-column: 2; grid-row: 1; }\n.div3 { grid-column: 2; grid-row: 2; }\n\n/* Expand inside column */\n.expand {\n  grid-row: 1 / span 2;\n}\n\n\n.thStyle {\n        border: 1px solid #ccc;      \n   background-color:#09564e;\n        color: white;\n        text-Align: center;\n        font-Size: 14px;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
